module.exports = __webpack_public_path__ + "static/media/38.60781b3a.jpg";